import axios from "axios";
import ApiBase from "./ApiBase";

class Event extends ApiBase
{
    async browseByCategory(eventCategoryId, skip = 0, take = 10) {
        return await this.get("event_category/" + eventCategoryId + "/event?skip=" + skip + "&take=" + take)
    }

    async read(eventCategoryId, eventId) {
        return await this.get("event_category/" + eventCategoryId + "/event/" + eventId)
    }
}

export default Event
